import { angular, AppModule } from './bootstrap';

const DEBUG = false;
const log = DEBUG
  ? console.log.bind(
      console,
      '%c[DEBUG][MOVER-APP][BOOTSTRAPPING]',
      'color: #286d5b'
    )
  : () => {};

const mountedInstance = {};

const addGlobalStyles = () => {
  if (window.__mover_app_styles) {
    window.__mover_app_styles.forEach(style => style.turnOn());
  } else {
    console.error('theyre not there!');
  }
};

const removeGlobalStyles = () => {
  if (window.__mover_app_styles) {
    window.__mover_app_styles.forEach(style => style.turnOff());
  } else {
    console.error('theyre not there!');
  }
};

export function bootstrap() {
  return Promise.resolve();
}

// RACE CONDITION ALERT:
// we have to store the CSS before we remove it
// because style-loader does not have the initial css on init
removeGlobalStyles();

let newHeaderEnabled = false;

export function mount({ container, interactors }) {
  interactors.journey.actions.hasNewHeaderPromise().then(enabled => {
    newHeaderEnabled = enabled;
    if (enabled) {
      interactors.header.actions.showMoverDropdown();
      interactors.header.actions.enableLogoClick();
    } else {
      interactors.header.actions.hide();
    }
  });

  addGlobalStyles();
  container.dispatchEvent(
    new Event('upd-app-loading', {
      bubbles: true,
    })
  );

  const el = document.createElement('upd-mover-app');
  container.appendChild(el);
  return new Promise(resolve => {
    angular.element(document).ready(function() {
      angular.module(AppModule.name).config(function(appShellProvider) {
        'ngInject';
        appShellProvider.interactors = interactors;
      });
      log('running angularjs');

      mountedInstance.instance = angular.bootstrap(el, [AppModule.name]);

      // Check to make sure angular is fully bootstrapped before resolving.
      // https://stackoverflow.com/questions/28392439/check-if-angularjs-module-is-bootstrapped
      const interval = setInterval(() => {
        const hiddenElementRendered = document.querySelector(
          '[mover-app-bootstrapped]'
        );
        const rootScope = angular.element(el).scope();
        log('intervaling', {
          rootScope,
          hiddenElementRendered,
        });

        if (hiddenElementRendered || rootScope) {
          log('done');
          clearInterval(interval);
          resolve();
        }
      }, 250);
    });
  });
}

export function unmount({ container, interactors }) {
  removeGlobalStyles();
  if (newHeaderEnabled) {
    interactors.header.actions.hideMoverDropdown();
    interactors.header.actions.disableLogoClick();
  } else {
    interactors.header.actions.show();
  }
  return new Promise(function(resolve) {
    mountedInstance.instance.get('$rootScope').$destroy();
    container.innerHTML = '';
    setTimeout(resolve);
  });
}
